import { Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    selector   : 'my-buttons',
    template: require('./buttons.component.html'),
    styles: [require('./buttons.component.scss')],
    encapsulation: ViewEncapsulation.None
})

export class ButtonsComponent {

    @Input() buttons: any;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/buttons/buttons.component.ts